import { render } from "./DialogPagamento.vue?vue&type=template&id=75f4a6e8"
import script from "./DialogPagamento.vue?vue&type=script&lang=js"
export * from "./DialogPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__